import { Translate } from '@dreryk/react-common';
import { StandardSpinner } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../translations';

import { EGabinetNews } from './NewsCard.hooks';
import { StyledNewsCardListElement, StyledNewsCardListElementDateAndTag } from './NewsCardListElementContent.styled';
import { StyledNewsCardListElementLinkNotFound } from './NewsCardListElementLinkNotFound.styled';

type NewsCardListElementRenderProps = {
   egabinetNews: EGabinetNews;
};

type NewsCardListElementLoaderProps = {
   readonly egabinetNews: EGabinetNews | undefined;
   readonly egabinetNewsLoading: boolean;
   readonly egabinetNewsError: Error | undefined;
   readonly children: (renderProps: NewsCardListElementRenderProps) => JSX.Element;
};

export const NewsCardListElementLoader = (props: NewsCardListElementLoaderProps): JSX.Element => {
   const { egabinetNews, egabinetNewsError, egabinetNewsLoading } = props;

   if (egabinetNewsLoading) {
      return (
         <StyledNewsCardListElement>
            <StandardSpinner />
         </StyledNewsCardListElement>
      );
   }

   if (!egabinetNews || egabinetNewsError) {
      return (
         <StyledNewsCardListElement>
            <StyledNewsCardListElementLinkNotFound testId={'newsNotFound'}>
               <Translate>{dashboardTranslationKeys.cards.newsNotFound}</Translate>
            </StyledNewsCardListElementLinkNotFound>
            <StyledNewsCardListElementDateAndTag>{'-'}</StyledNewsCardListElementDateAndTag>
         </StyledNewsCardListElement>
      );
   }

   return props.children({
      egabinetNews: egabinetNews,
   });
};
